// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__1gnr_","rootNoMargin":"styles_rootNoMargin__1109_"};